module.exports = require('./readable').PassThrough



//////////////////
// WEBPACK FOOTER
// /root/anvel/~/readable-stream/passthrough.js
// module id = ../../../../readable-stream/passthrough.js
// module chunks = 4